import { ISelectOption } from '~/commonComponents/InputSelect';
import { DashboardJobsType } from '~/domain/DashboardJobs';

export const FilterOptions: ISelectOption[] = [
  {
    title: 'All',
    value: DashboardJobsType.ALL,
  },
  {
    title: 'Interview',
    value: DashboardJobsType.INTERVIEW,
  },
  {
    title: 'Shift',
    value: DashboardJobsType.SHIFT,
  },
];
